import { CircularProgress } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
interface ILoadingProps {}
const Loading: FunctionComponent<ILoadingProps> = ({
  children
}) => {
  return <div data-sentry-component="Loading" data-sentry-source-file="Loading.tsx">
            <CircularProgress data-sentry-element="CircularProgress" data-sentry-source-file="Loading.tsx" />
        </div>;
};
export default Loading;